import React, { useEffect, useRef, useState } from "react"
import ContactForm from "../components/contactForm"
import SideBar from "../components/contactSidebar"

export default function ContactOverlay() {
  const [isOpen, setIsOpen] = useState(false)
  const [active, setActive] = useState("general")

  const openPanel = type => {
    setActive(type === "trade" ? "trade" : "general")
    setIsOpen(true)
    requestAnimationFrame(() => document.body.classList.add("popup-open"))
  }

  const closePanel = () => {
    document.body.classList.remove("popup-open")
    setIsOpen(false)
  }

  useEffect(() => {
    const onOpen = e => openPanel(e?.detail?.type)
    const onKeyDown = e => e.key === "Escape" && closePanel()
    window.addEventListener("open-contact-overlay", onOpen)
    window.addEventListener("keydown", onKeyDown)
    return () => {
      window.removeEventListener("open-contact-overlay", onOpen)
      window.removeEventListener("keydown", onKeyDown)
    }
  }, [])

  const now = new Date()
  const formatted = now.toLocaleString("en-AU", {
    weekday: "long",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  })

  return (
    <>
      <div className={`contact--overlay common-grid ${isOpen ? "is-mounted" : ""}`}>
        <div className='panel flex flex-col'>
          <div className='inner flex space-between m-mb8'>
            <p>{formatted}</p>
            <p className='button' onClick={closePanel} role='presentation'>Close</p>
          </div>
          <div className='inner mta mba grid-8 grid align-center'>
            <div className='col-4 m-col-12 flex flex-col gap-48 m-gap-32'>
              <p className='h2 '>{active === "trade" ? "Trade Enquiries" : "General Enquiries"}</p>
              <div style={{ display: active === "general" ? "block" : "none" }}>
                <ContactForm type='general' onClose={closePanel} />
              </div>
              <div style={{ display: active === "trade" ? "block" : "none" }}>
                <ContactForm type='trade' onClose={closePanel} />
              </div>
              <SwitchLinks active={active} onSwitch={setActive} />
            </div>
            <div className='col-2 m-hide' />
            <div className='col-2 m-col-12'>
              <SideBar />
            </div>
          </div>
        </div>
      </div>
      <div onClick={closePanel} className='contact--bg' role='presentation' />
    </>
  )
}

const SwitchLinks = ({ active, onSwitch }) => {
  return (
    <div className='op-50'>
      {active === "general" ? (
        <>
          *General project enquiries only.<br />
          For product-related requests, <span className='ul pointer' onClick={() => onSwitch("trade")} role='presentation'>click here for trade contact.</span>
        </>
      ) : (
        <>
          *Trade enquiries only.<br />
          For project-related requests, <span className='ul pointer' onClick={() => onSwitch("general")} role='presentation'>click here for general enquiries.</span>
        </>
      )}
    </div>
  )
}